import { getErrorRes, getSuccessRes } from "../helpers/api-response";
import { handleErrorMessage } from "../helpers/handle-error-message";
import logger from "../helpers/logger";
import axiosIns from "../common/interceptor/axios-interceptor";

//Gas
//Fetch Gas data
export const fetchGasData = async (noCache = false) => {
  try {
    const res = await axiosIns.get(`rackstar/wetmovegas`, {
      params: { noCache },
    });
    return getSuccessRes(res.data || [], "Gas data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Gas data.`);
  }
};

//Delete Gas
export const deleteGasData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/wetmovegas/${id}`
    );
    return getSuccessRes(res.data || [], "Gas data deleted successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Gas data.`);
  }
};

// Update an existing Gas entry
export const updateGasData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/wetmovegas/${id}`,
      data
    );
    return getSuccessRes(res.data, "Gas data updated successfully!");
  } catch (error) {
    logger.error("updateGasData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Gas Data.");
  }
};

//Add a Gas data
export const addGasData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/wetmovegas`,
      data
    );
    return getSuccessRes(res.data, "Gas data added successfully!");
  } catch (error) {
    logger.error("addGasData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Gas data.");
  }
};

//Diesel
//Fetch Diesel data
export const fetchDieselData = async (noCache = false) => {
  try {
    const res = await axiosIns.get(`rackstar/wetmovedsl`, {
      params: { noCache },
    });
    return getSuccessRes(res.data || [], "Diesel data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Diesel data.`);
  }
};

//Delete Diesel
export const deleteDieselData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/wetmovedsl/${id}`
    );
    return getSuccessRes(res.data || [], "Diesel data deleted successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Diesel data.`);
  }
};

// Update an existing Diesel entry
export const updateDieselData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/wetmovedsl/${id}`,
      data
    );
    return getSuccessRes(res.data, "Diesel data updated successfully!");
  } catch (error) {
    logger.error("updateDieselData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Diesel Data.");
  }
};

//Add a Diesel data
export const addDieselData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/wetmovedsl`,
      data
    );
    return getSuccessRes(res.data, "Diesel data added successfully!");
  } catch (error) {
    logger.error("addDieselData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Diesel data.");
  }
};

//Configuration
//Fetch Configuration data
export const fetchConfigurationData = async () => {
  try {
    const res = await axiosIns.get(`rackstar/wetmoveconfig`);
    return getSuccessRes(
      res.data || [],
      "Configuration data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Configuration data.`);
  }
};

//Delete Configuration
export const deleteConfigurationData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/wetmoveconfig/${id}`
    );
    return getSuccessRes(
      res.data || [],
      "Configuration data deleted successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Configuration data.`);
  }
};

// Update an existing Configuration entry
export const updateConfigurationData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/wetmoveconfig/${id}`,
      data
    );
    return getSuccessRes(res.data, "Configuration data updated successfully!");
  } catch (error) {
    logger.error("updateConfigurationData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Configuration Data.");
  }
};

//Add a Configuration data
export const addConfigurationData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/wetmoveconfig`,
      data
    );
    return getSuccessRes(res.data, "Configuration data added successfully!");
  } catch (error) {
    logger.error("addConfigurationData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Configuration data.");
  }
};

//Fetch Preview data
export const fetchPreviewData = async (formattedDate, toastId) => {
  try {
    const res = await axiosIns.get(
      `rackstar/preview-wetmove?inputDate=${formattedDate}`
    );
    return getSuccessRes(res.data || [], "Preview data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, `Failed to fetch Preview data.`);
  }
};

//Update Wet move date
export const updateWetMoveDate = async (formattedDate, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/update-wetmove`,
      { inputDate: formattedDate }
    );
    return getSuccessRes(res.data, "Updated wet move date successfully!");
  } catch (error) {
    logger.error("updateWetMoveDate", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update wet move date.");
  }
};

//Fetch Wet Move data
export const fetchWetMoveDataByDate = async (
  formattedDate,
  toastId = false
) => {
  try {
    const res = await axiosIns.get(
      `rackstar/wetmove/date?date=${formattedDate}`
    );
    return getSuccessRes(res.data || [], "Wet Move date fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true, toastId ?? "");
    throw getErrorRes(errMessage, `Failed to fetched Wet Move date.`);
  }
};
